import { scroller } from "react-scroll";

export const  ScrollToElement = (elementId: string) => {
  scroller.scrollTo(elementId, {
    duration: 800,
    delay: 0,
    smooth: 'easeOutQuad'
  })
}